// /* global __DEV__ */
import React, { Component, PureComponent } from 'react';
import EBankingApp from './ebanking-app';
import routerLite from '../muster/pre-login';
import settings from '../data/settings.json';
import { Provider } from '@dbk-legacy/muster/react';
import LoginScreen from '../screens/user/login/login.container';
import PreLoginApp from '../components/app/pre-login-app';
import LoginWrapper from '../components/login-wrapper';
import AuthenticatedWrapper from '../components/authenticated-wrapper';
import EbankingStyle from './ebanking.style';
import InverseProvider from '@dbk/ui-inverse';
import { View } from '@dbk/ui-react-utils';

// global.fulLRoster = router(settings.environments[settings.defaultEnvironment].remoteUrl).run();
class EBankingDev extends PureComponent {

  constructor(props) {
    super(props);
    this.onLoginChange = this.onLoginChange.bind(this);
    this.userGotPortfolio = this.userGotPortfolio.bind(this);
    this.onLanguageChange = this.onLanguageChange.bind(this);
    this.state = {
      LoginCredentials: "",
      loadFUllRoster: global.fulLRoster,
      rosterLite: null,
      userGotPortfolio: false
    };
  }

  onLoginChange(loginJson) {
    this.setState({ LoginCredentials: loginJson });
  }

  onLanguageChange() {
    const ROSTER_URL = settings.environments[settings.defaultEnvironment].remoteUrl;
    this.setState({
      rosterLite: routerLite(ROSTER_URL).run()
    });

  }

  userGotPortfolio() {
    if (this.state.userGotPortfolio == false) {
      this.setState({ userGotPortfolio: true });
    }
  }

  checkFullRoster() {
    setTimeout(() => {
      const router = require('../muster').default;
      this.setState({
        loadFUllRoster: router(settings.environments[settings.defaultEnvironment].remoteUrl).run()
      });

    }, 500);
  }

  componentDidMount() {
    const ROSTER_URL = settings.environments[settings.defaultEnvironment].remoteUrl;
    this.setState({
      rosterLite: routerLite(ROSTER_URL).run()
    });
    this.checkFullRoster();
  }

  render = () => {

    return (
      //WMCE-455: Reduced muster initialization -- Split muster initialization into 2 providers
      <div style={{ flex: 1 }}>
        {this.state.userGotPortfolio == false && this.state.rosterLite != null && this.state.loadFUllRoster === null &&
          <Provider routes={this.state.rosterLite} >
            <div style={{ flex: 1, backgroundColor: '#000E28', height: '100%' }}>
              <InverseProvider inverse style={this.props.style}>
                 <LoginWrapper onLoginChange={this.onLoginChange} >
                  <View style={EbankingStyle.loginBG}>
                    <EBankingApp style={this.props.style}>
                        <PreLoginApp />
                    </EBankingApp>
                  </View>
                </LoginWrapper>
              </InverseProvider>
            </div>
          </Provider>
        }
        {this.state.loadFUllRoster != null && Object.keys(this.state.loadFUllRoster).length > 0 &&
          <Provider routes={this.state.loadFUllRoster} >
            {this.state.LoginCredentials != '' &&
              <AuthenticatedWrapper userGotPortfolio={this.userGotPortfolio} authenticationJson={this.state.LoginCredentials}>
              </AuthenticatedWrapper>
            }
            <EBankingApp style={this.state.userGotPortfolio == '' ? EbankingStyle.rootHide : EbankingStyle.root}>
              <View style={{ flex: 1 }}>
                {this.props.children}
              </View>
            </EBankingApp>
          </Provider>
        }
      </div>
    );
  }
}
export default EBankingDev;

